<template>
  <iframe :src="chatUrl" frameborder="0" style="width: 100%; height: 100%;"></iframe>
</template>

<script>
export default {
  data() {
    return {
      chatUrl: `${process.env.VUE_APP_CHAT_URL}?id=${this.$store.getters.userId}`
    }
  }
}
</script>

<style>

</style>